import * as actionTypes from "./constants";
import * as Service from "./services";

const isSuccessfulResponse = res => res && res.status >= 200 && res.status < 300;

const getDynamicTables = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLES_REQUEST });
            const res = await Service.getDynamicTables(params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLES_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLES_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLES_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getPublishedDynamicTables = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_PUBLISHED_DYNAMIC_TABLES_REQUEST });
            const res = await Service.getDynamicTablesDropdown(params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_PUBLISHED_DYNAMIC_TABLES_SUCCESS, response: res.data?.data });
            } else {
                dispatch({ type: actionTypes.GET_PUBLISHED_DYNAMIC_TABLES_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_PUBLISHED_DYNAMIC_TABLES_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableById = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BY_ID_REQUEST });
            const res = await Service.getDynamicTableById(id);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BY_ID_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BY_ID_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BY_ID_FAILURE, error: e.response && e.response.data });
        }
    };
};

const addDynamicTable = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_REQUEST });
            const res = await Service.addDynamicTable(params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FAILURE, error: e.response && e.response.data });
        }
    };
};

const updateDynamicTable = (id, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_REQUEST });
            const res = await Service.updateDynamicTable(id, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FAILURE, error: e.response && e.response.data });
        }
    };
};

const deleteDynamicTable = (id, isPermanent) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_REQUEST });
            const res = await Service.deleteDynamicTable(id, isPermanent);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FAILURE, error: e.response && e.response.data });
        }
    };
};

// get_list nests its payload under `data`; unwrap it so Table.jsx can read `.list`/`.count` directly.
const getListForDynamicTableFilter = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_REQUEST });
            const res = await Service.getListForDynamicTableFilter({
                field: params.field,
                direction: params.direction || "asc",
                limit: 100,
                search: params.search,
                search_filters: params.search_filters,
                client_id: params.client_id,
                project_id: params.project_id,
                filters: params.filters,
                list: params.list,
                field_filter: params.field_filter
            });
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_SUCCESS, response: res.data?.data });
                return res.data?.data;
            } else {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const clearTableEntityParams = sections => ({ type: actionTypes.CLEAR_DYNAMIC_TABLE_ENTITY_PARAMS, sections });

const getDynamicTableBands = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BANDS_REQUEST });
            const res = await Service.getDynamicTableBands(tableId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BANDS_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BANDS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_BANDS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const addDynamicTableBand = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_BAND_REQUEST });
            const res = await Service.addDynamicTableBand(tableId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_BAND_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_BAND_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_BAND_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_BAND_FAILURE, error: e.response && e.response.data });
        }
    };
};

const updateDynamicTableBand = (tableId, bandId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_BAND_REQUEST });
            const res = await Service.updateDynamicTableBand(tableId, bandId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_BAND_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_BAND_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_BAND_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_BAND_FAILURE, error: e.response && e.response.data });
        }
    };
};

const deleteDynamicTableBand = (tableId, bandId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_BAND_REQUEST });
            const res = await Service.deleteDynamicTableBand(tableId, bandId);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_BAND_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_BAND_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_BAND_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_BAND_FAILURE, error: e.response && e.response.data });
        }
    };
};

// Only "name" is whitelisted for search/filter/dropdown on bands - see services.js.
const getListForDynamicTableBandFilter = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_REQUEST });
            const res = await Service.getListForDynamicTableBandFilter(tableId, {
                field: params.field,
                direction: params.direction || "asc",
                limit: 100,
                search: params.search,
                search_filters: params.search_filters,
                filters: params.filters,
                list: params.list
            });
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_SUCCESS, response: res.data?.data });
                return res.data?.data;
            } else {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_BAND_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableFields = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_REQUEST });
            const res = await Service.getDynamicTableFields(tableId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableFieldsGrouped = tableId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_GROUPED_REQUEST });
            const res = await Service.getDynamicTableFieldsGrouped(tableId);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_GROUPED_SUCCESS, response: { ...res.data?.data, tableId } });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_GROUPED_FAILURE, error: { ...(res.response && res.response.data), tableId } });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELDS_GROUPED_FAILURE, error: { ...(e.response && e.response.data), tableId } });
        }
    };
};

const getDynamicTableFieldById = (tableId, fieldId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELD_BY_ID_REQUEST });
            const res = await Service.getDynamicTableFieldById(tableId, fieldId);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELD_BY_ID_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELD_BY_ID_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_FIELD_BY_ID_FAILURE, error: e.response && e.response.data });
        }
    };
};

const addDynamicTableField = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FIELD_REQUEST });
            const res = await Service.addDynamicTableField(tableId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FIELD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FIELD_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FIELD_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_FIELD_FAILURE, error: e.response && e.response.data });
        }
    };
};

const updateDynamicTableField = (tableId, fieldId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FIELD_REQUEST });
            const res = await Service.updateDynamicTableField(tableId, fieldId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FIELD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FIELD_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FIELD_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_FIELD_FAILURE, error: e.response && e.response.data });
        }
    };
};

const deleteDynamicTableField = (tableId, fieldId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FIELD_REQUEST });
            const res = await Service.deleteDynamicTableField(tableId, fieldId);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FIELD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FIELD_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FIELD_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_FIELD_FAILURE, error: e.response && e.response.data });
        }
    };
};

const reorderDynamicTableFields = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.REORDER_DYNAMIC_TABLE_FIELDS_REQUEST });
            const res = await Service.reorderDynamicTableFields(tableId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.REORDER_DYNAMIC_TABLE_FIELDS_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.REORDER_DYNAMIC_TABLE_FIELDS_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.REORDER_DYNAMIC_TABLE_FIELDS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.REORDER_DYNAMIC_TABLE_FIELDS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getListForDynamicTableFieldFilter = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_REQUEST });
            const res = await Service.getListForDynamicTableFieldFilter(tableId, {
                field: params.field,
                direction: params.direction || "asc",
                limit: 100,
                search: params.search,
                search_filters: params.search_filters,
                filters: params.filters,
                list: params.list
            });
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_SUCCESS, response: res.data?.data });
                return res.data?.data;
            } else {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_FIELD_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORDS_REQUEST });
            const res = await Service.getDynamicTableRecords(tableId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORDS_SUCCESS, response: { ...res.data, tableId } });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORDS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORDS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableRecordTotals = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_TOTALS_REQUEST });
            const res = await Service.getDynamicTableRecordTotals(tableId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_TOTALS_SUCCESS, response: { ...res.data, tableId } });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_TOTALS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_TOTALS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableRecordById = (tableId, recordId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_BY_ID_REQUEST });
            const res = await Service.getDynamicTableRecordById(tableId, recordId);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_BY_ID_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_BY_ID_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_BY_ID_FAILURE, error: e.response && e.response.data });
        }
    };
};

const addDynamicTableRecord = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_RECORD_REQUEST });
            const res = await Service.addDynamicTableRecord(tableId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_RECORD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_RECORD_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_RECORD_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.ADD_DYNAMIC_TABLE_RECORD_FAILURE, error: e.response && e.response.data });
        }
    };
};

const updateDynamicTableRecord = (tableId, recordId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_RECORD_REQUEST });
            const res = await Service.updateDynamicTableRecord(tableId, recordId, params);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_RECORD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_RECORD_FAILURE, error: data });
                }
            } else {
                dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_RECORD_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_RECORD_FAILURE, error: e.response && e.response.data });
        }
    };
};

const deleteDynamicTableRecord = (tableId, recordId) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_RECORD_REQUEST });
            const res = await Service.deleteDynamicTableRecord(tableId, recordId);
            if (isSuccessfulResponse(res)) {
                const data = res.data || { success: true };
                if (data.success) {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_RECORD_SUCCESS, response: data });
                } else {
                    dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_RECORD_FAILURE, error: data });
                }
                return data;
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_RECORD_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.DELETE_DYNAMIC_TABLE_RECORD_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const getRecordCommonDataByIds = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_REQUEST });
            const res = await Service.getDynamicTableRecordCommonData(tableId, params);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_COMMON_DATA_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const resetRecordCommonData = () => {
    return dispatch => dispatch({ type: actionTypes.RESET_DYNAMIC_TABLE_RECORD_COMMON_DATA });
};

const bulkEditRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.BULK_EDIT_DYNAMIC_TABLE_RECORDS_REQUEST });
            const res = await Service.bulkEditDynamicTableRecords(tableId, params);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.BULK_EDIT_DYNAMIC_TABLE_RECORDS_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.BULK_EDIT_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.BULK_EDIT_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const bulkDeleteRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.BULK_DELETE_DYNAMIC_TABLE_RECORDS_REQUEST });
            const res = await Service.bulkDeleteDynamicTableRecords(tableId, params);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.BULK_DELETE_DYNAMIC_TABLE_RECORDS_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.BULK_DELETE_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.BULK_DELETE_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

// Records get_list takes `field_id` (a field UUID) rather than `field` as the other get_list endpoints do.
const getListForDynamicTableRecordFilter = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_REQUEST });
            const res = await Service.getListForDynamicTableRecordFilter(tableId, {
                field_id: params.field,
                offset: 0,
                limit: 100,
                search: params.search,
                search_filters: params.search_filters,
                filters: params.filters,
                list: params.list,
                entity_type: params.entity_type,
                entity_id: params.entity_id,
                include_assignment: params.include_assignment
            });
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_SUCCESS, response: res.data });
                return res.data;
            }
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_FAILURE, error: res.response && res.response.data });
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_DYNAMIC_TABLE_RECORD_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getDynamicTableRecordLinkedEntities = (tableId, recordId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_REQUEST });
            const res = await Service.getDynamicTableRecordLinkedEntities(tableId, recordId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_RECORD_LINKED_ENTITIES_FAILURE, error: e.response && e.response.data });
        }
    };
};

// get_list nests its payload under `data`; unwrap it so Table.jsx reads `.list`/`.count` off commonFilterData.
const getListForLinkedEntityFilter = (tableId, recordId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_LINKED_ENTITY_FILTER_REQUEST });
            const res = await Service.getListForLinkedEntityFilter(tableId, recordId, params);
            if (res && res.status === 200) {
                const response = res.data?.data ?? res.data;
                dispatch({ type: actionTypes.GET_LIST_FOR_LINKED_ENTITY_FILTER_SUCCESS, response });
                return response;
            }
            dispatch({ type: actionTypes.GET_LIST_FOR_LINKED_ENTITY_FILTER_FAILURE, error: res.response && res.response.data });
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_LINKED_ENTITY_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getEntityDynamicTables = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ENTITY_DYNAMIC_TABLES_REQUEST });
            const res = await Service.getDynamicTables(params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_ENTITY_DYNAMIC_TABLES_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_ENTITY_DYNAMIC_TABLES_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_ENTITY_DYNAMIC_TABLES_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getAssignPickerRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ASSIGN_PICKER_RECORDS_REQUEST });
            const res = await Service.getDynamicTableRecords(tableId, params);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_ASSIGN_PICKER_RECORDS_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.GET_ASSIGN_PICKER_RECORDS_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.GET_ASSIGN_PICKER_RECORDS_FAILURE, error: e.response && e.response.data });
        }
    };
};

const getListForAssignPickerFilter = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_ASSIGN_PICKER_FILTER_REQUEST });
            const res = await Service.getListForDynamicTableRecordFilter(tableId, {
                field_id: params.field,
                offset: 0,
                limit: 100,
                search: params.search,
                search_filters: params.search_filters,
                filters: params.filters,
                list: params.list,
                entity_type: params.entity_type,
                entity_id: params.entity_id,
                include_assignment: params.include_assignment
            });
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_LIST_FOR_ASSIGN_PICKER_FILTER_SUCCESS, response: res.data });
                return res.data;
            }
            dispatch({ type: actionTypes.GET_LIST_FOR_ASSIGN_PICKER_FILTER_FAILURE, error: res.response && res.response.data });
        } catch (e) {
            dispatch({ type: actionTypes.GET_LIST_FOR_ASSIGN_PICKER_FILTER_FAILURE, error: e.response && e.response.data });
        }
    };
};

const bulkAssignRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST });
            const res = await Service.bulkAssignDynamicTableRecords(tableId, params);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.BULK_ASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const bulkUnassignRecords = (tableId, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_REQUEST });
            const res = await Service.bulkUnassignDynamicTableRecords(tableId, params);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_SUCCESS, response: res.data });
                return { success: true, ...res.data };
            }
            const error = res.response && res.response.data;
            dispatch({ type: actionTypes.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        } catch (e) {
            const error = e.response && e.response.data;
            dispatch({ type: actionTypes.BULK_UNASSIGN_DYNAMIC_TABLE_RECORDS_FAILURE, error });
            return { success: false, ...error };
        }
    };
};

const clearAssignResponses = () => {
    return dispatch => dispatch({ type: actionTypes.CLEAR_DYNAMIC_TABLE_ASSIGN_RESPONSES });
};

// The template request is `responseType: "blob"`, so error bodies arrive as a Blob, not parsed JSON.
const readBlobError = async data => {
    if (!(data instanceof Blob)) return data;
    try {
        return JSON.parse(await data.text());
    } catch (e) {
        return null;
    }
};

// Content-Disposition carries both `filename` and the RFC 5987 `filename*`; splitting on "filename=" would keep the tail.
const getFileNameFromHeaders = (headers, fallback) => {
    const disposition = headers?.["content-disposition"] || "";
    const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (encoded) {
        try {
            return decodeURIComponent(encoded[1].trim());
        } catch (e) {
            return encoded[1].trim();
        }
    }
    const plain = disposition.match(/filename="?([^";]+)"?/i);
    return plain ? plain[1].trim() : fallback;
};

const exportDynamicTableRecords = (tableId, params) => {
    return async dispatch => {
        try {
            const response = await Service.exportDynamicTableRecords(tableId, params);
            const { data } = response;
            const fileName = getFileNameFromHeaders(response.headers, "records.xlsx");
            const blob = new Blob([data]);
            const url = window.URL || window.webkitURL;
            const downloadUrl = url.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            return { success: true };
        } catch (e) {
            const error = await readBlobError(e.response && e.response.data);
            return { success: false, ...error };
        }
    };
};

const getDynamicTableImportTemplate = tableId => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_REQUEST });
            const response = await Service.getDynamicTableImportTemplate(tableId, { include_hints: false });
            const { data } = response;
            const fileName = getFileNameFromHeaders(response.headers, "import_template.xlsx");
            const blob = new Blob([data]);
            const url = window.URL || window.webkitURL;
            const downloadUrl = url.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_SUCCESS, response: {} });
        } catch (e) {
            const error = await readBlobError(e.response && e.response.data);
            dispatch({ type: actionTypes.GET_DYNAMIC_TABLE_IMPORT_TEMPLATE_FAILURE, error });
        }
    };
};

const validateDynamicTableImport = (tableId, file, options = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.VALIDATE_DYNAMIC_TABLE_IMPORT_REQUEST });
            const formData = new FormData();
            formData.append("file", file);
            if (options.sheetName) formData.append("sheet_name", options.sheetName);
            formData.append("header_row", options.headerRow || 1);
            // Omitted rather than defaulted, so the server keeps resolving it as header_row + 1.
            if (options.dataStartRow) formData.append("data_start_row", options.dataStartRow);
            // Always on, so unmatched headers reach the mapping screen instead of 422-ing; `mappings` decides.
            formData.append("allow_new_columns", true);
            const res = await Service.validateDynamicTableImport(tableId, formData, options.onUploadProgress);
            if (res && res.status === 200) {
                dispatch({ type: actionTypes.VALIDATE_DYNAMIC_TABLE_IMPORT_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.VALIDATE_DYNAMIC_TABLE_IMPORT_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.VALIDATE_DYNAMIC_TABLE_IMPORT_FAILURE, error: e.response && e.response.data });
        }
    };
};

const confirmDynamicTableImport = (tableId, options = {}) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CONFIRM_DYNAMIC_TABLE_IMPORT_REQUEST });
            const formData = new FormData();
            if (options.s3Key) formData.append("s3_key", options.s3Key);
            if (options.fileName) formData.append("file_name", options.fileName);
            if (options.file) formData.append("file", options.file);
            if (options.sheetName) formData.append("sheet_name", options.sheetName);
            formData.append("header_row", options.headerRow || 1);
            if (options.dataStartRow) formData.append("data_start_row", options.dataStartRow);
            formData.append("allow_new_columns", !!options.allowNewColumns);
            if (options.mappings) formData.append("mappings", JSON.stringify(options.mappings));
            if (options.importMode) formData.append("import_mode", options.importMode);
            if (options.uniqueKey) formData.append("unique_key", JSON.stringify(options.uniqueKey));
            // Echoing this back lets the server skip re-reading the data rows.
            if (options.totalRows != null) formData.append("total_rows", options.totalRows);
            const res = await Service.confirmDynamicTableImport(tableId, formData);
            if (isSuccessfulResponse(res)) {
                dispatch({ type: actionTypes.CONFIRM_DYNAMIC_TABLE_IMPORT_SUCCESS, response: res.data });
            } else {
                dispatch({ type: actionTypes.CONFIRM_DYNAMIC_TABLE_IMPORT_FAILURE, error: res.response && res.response.data });
            }
        } catch (e) {
            dispatch({ type: actionTypes.CONFIRM_DYNAMIC_TABLE_IMPORT_FAILURE, error: e.response && e.response.data });
        }
    };
};

const clearImportValidation = () => {
    return async dispatch => {
        dispatch({ type: actionTypes.CLEAR_DYNAMIC_TABLE_IMPORT_VALIDATION });
    };
};

const updateEntityParams = (entityParams, section) => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_SUCCESS, response: entityParams, section });
            }
        } catch (e) {
            dispatch({ type: actionTypes.UPDATE_DYNAMIC_TABLE_ENTITY_PARAMS_FAILURE, error: entityParams, section });
        }
    };
};

const clearResponseData = () => {
    return async dispatch => {
        dispatch({ type: actionTypes.CLEAR_DYNAMIC_TABLE_RESPONSES });
    };
};

export default {
    getDynamicTables,
    getPublishedDynamicTables,
    getDynamicTableById,
    addDynamicTable,
    updateDynamicTable,
    deleteDynamicTable,
    getListForDynamicTableFilter,
    getDynamicTableBands,
    addDynamicTableBand,
    updateDynamicTableBand,
    deleteDynamicTableBand,
    getListForDynamicTableBandFilter,
    getDynamicTableFields,
    getDynamicTableFieldsGrouped,
    getDynamicTableFieldById,
    addDynamicTableField,
    updateDynamicTableField,
    deleteDynamicTableField,
    reorderDynamicTableFields,
    getListForDynamicTableFieldFilter,
    getDynamicTableRecords,
    getDynamicTableRecordTotals,
    exportDynamicTableRecords,
    getDynamicTableRecordById,
    addDynamicTableRecord,
    updateDynamicTableRecord,
    deleteDynamicTableRecord,
    getRecordCommonDataByIds,
    resetRecordCommonData,
    bulkEditRecords,
    bulkDeleteRecords,
    getListForDynamicTableRecordFilter,
    getDynamicTableRecordLinkedEntities,
    getListForLinkedEntityFilter,
    getEntityDynamicTables,
    getAssignPickerRecords,
    getListForAssignPickerFilter,
    bulkAssignRecords,
    bulkUnassignRecords,
    clearAssignResponses,
    getDynamicTableImportTemplate,
    validateDynamicTableImport,
    confirmDynamicTableImport,
    clearImportValidation,
    updateEntityParams,
    clearTableEntityParams,
    clearResponseData
};
